import mapperIcon from '#layers/core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page Privacy Policy mapper
 * normalizes data to be used in pages
 */

export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  // The same subpages will be shown in card format and on the page navigation
  const subpages = data.itemsCollection?.items.filter(Boolean).map((item: any) => ({
    title: item.navigationTitle || '',
    // For sidebar navigation
    url: options.getInternalUrl(item.sys.id),
    // For subpages cards
    link: {
      url: options.getInternalUrl(item.sys.id),
      title: item.navigationTitle || '',
      ariaLabel: item.navigationTitle || ''
    },
    text: item.navigationDescription || '',
    icon: mapperIcon(item?.icon)
  })) || []

  return {
    contentLocale: data.locale || '',
    introText: data.introText || null,
    highlightText: data.highlightText || null,
    defaultLocaleFallbackEnabled: data.defaultLocaleFallbackEnabled || false,
    // null check of subchapters done in the chapter.vue component
    chapters: data.chaptersCollection?.items?.filter(Boolean) || [],
    itemsTitle: data.itemsTitle || '',
    itemsDescription: data.itemsDescription || '',
    items: subpages,
    navigationItems: subpages
  }
}
